/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import {
  SmartComponentProps
} from '@exo/frontend-common-utils';
import { useEffect } from 'react';
import useAxios from 'axios-hooks';
import { renderPolarisLoading } from '@exo/frontend-features-insurance-chrome-logic';
import { AxiosError } from 'axios';

export const PolarisLoginContainer = ({
  render,
  loginEndpoint
}: Props) => {
  const [{ loading: postLoading, error: postError, response }, executePost] = useAxios(
    {
      url: loginEndpoint,
      method: 'POST'
    },
    {
      manual: true
    }
  );

  useEffect(() => {
    renderPolarisLoading(postLoading);
  }, [postLoading]);

  const onLogin = async (input: { username: string; password: string }) => {
    await executePost({ data: input })
  };

  return render({
    onSubmit: onLogin,
    submitResponse: response?.request,
    errors: postError
  });
};

type PolarisLoginContainerRenderProps = {
  onSubmit: (input: any) => any;
  submitResponse?: any;
  errors: AxiosError<any, any> | null;
};

type Props = SmartComponentProps<{
  render: (props: PolarisLoginContainerRenderProps) => JSX.Element;
  loginEndpoint: string;
}>;

